module.exports = __webpack_public_path__ + "img/logo-woco-dealliantie-white.bab2bf5d.png";